import { render, staticRenderFns } from "./MFormMpsTextField.vue?vue&type=template&id=2edfe5ca&scoped=true"
import script from "./MFormMpsTextField.vue?vue&type=script&lang=js"
export * from "./MFormMpsTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edfe5ca",
  null
  
)

export default component.exports